import { getGlobalConfig } from '../globalConfig';

export function getApiUrl(): string {
  return getGlobalConfig().apiUrl;
}

export function getWSSUrl(): string {
  return getGlobalConfig().wssUrl;
}

export function getMyInterviewAPIKey(): string {
  return getGlobalConfig().myInterviewAPIKey;
}
